export const queryKeys = {
    WEBSITE:"WEBSITE",
    CRON: "CRON"
}